import { ArcGisAddProtocolProps, ArcGisDictionaryProps, ArcGisQueryCountProps, ArcGisServiceProps, ProtocolIds } from './types/arcGisServiceProps';
import * as query from "@arcgis/core/rest/query.js";
import { FieldsToHeaders } from "../../helpers/featureTableConstruct";
import esriRequest from "@arcgis/core/request.js";
import { httpPost } from '../httpService/httpService';
import { makeCancelable } from "../../helpers/promise";

export const tableFeatureService = (props: ArcGisServiceProps, _query: __esri.Query, excludedHeaders?: string[]) => {
    let featureSetQuery = queryFeatureSet(props, _query, excludedHeaders);
    let promises = Promise.all([featureSetQuery.promise, queryCount({url: props.url, where: _query.where})]).then((res: any) => {
        return { featureSet: res[0], count: res[1]}
    });
    
    return {
        promise: promises,
        cancel() {
            featureSetQuery.cancel();
        }
    }
}

export const queryFeatureSet = (props: ArcGisServiceProps, _query: __esri.Query, excludedHeaders?: string[]) => {
    return makeCancelable(query.executeQueryJSON(props.url, _query).then((featureSet: __esri.FeatureSet) => {
        // const fixFeatureSet = fixId(featureSet);
        const headers = FieldsToHeaders(featureSet.fields, excludedHeaders);
        return {
            // data: fixFeatureSet.features,
            data: featureSet.features,
            headers: headers
        }
    }))
}

export const makeQuery = async (props: ArcGisServiceProps, _query: __esri.Query) => {
    const featureSet = await query.executeQueryJSON(props.url, _query);
    return featureSet;
}

export const queryCount = (props: ArcGisQueryCountProps) => {
    return query.executeForCount(props.url, { where: props.where });
}

export const portalUserService = (props: ArcGisServiceProps) => {
    const urlSearchParams = new URLSearchParams({
        f: "json"
    });
    return new Promise((resolve, reject) => {
        esriRequest(props.url, {
            query: urlSearchParams,
            responseType: "json"
        }).then((response: __esri.RequestResponse) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error);
        })
    })
}

export const addProtocol = async (props: ArcGisAddProtocolProps) => {

    let archId: any,
        globalId: any;

    const formData = new FormData();

    await query.executeQueryJSON(props.url, { where: props.where, outFields: ["ARCH_ID", "GLOBALID"], returnGeometry: false })
        .then((res) => {
            archId = res.features[0].attributes["ARCH_ID"];
            globalId = res.features[0].attributes["GLOBALID"];

            formData.append('IdNumber', props.idNumber);
            formData.append('ArchId', archId);
            formData.append('GlobalId', globalId);
            formData.append('IsLandslide', JSON.stringify(props.isLandslide));
        })
        .catch((err) => {
            console.log("err Query: ", err)
        })

    return new Promise((resolve, reject) => (
        httpPost(`${props.apiBase}/create-protocol`, formData)
            .then((res: any) => {
                resolve(res.data);
            })
            .catch((error: any) => {
                reject(error);
            })
    ));
}

export const correctProtocol = async (apiBase: string, protocolIds: ProtocolIds[]) => {

    const formData = new FormData();
    formData.append('ProtocolIds', JSON.stringify(protocolIds));
    
    return new Promise((resolve, reject) => (
        httpPost(`${apiBase}/correct-protocol`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    ));
}

export const getDictionaries = async (props: ArcGisDictionaryProps) => {
    const urlSearchParams = new URLSearchParams({
        f: "json",
    });
    const response = await esriRequest(props.url, {
        query: urlSearchParams,
        responseType: "json"
    });
    var features: __esri.FeatureLayer[] = [];
    if(response.data.layers !== undefined) features = features.concat(response.data.layers as __esri.FeatureLayer[]);
    if(response.data.tables !== undefined) features = features.concat(response.data.tables as __esri.FeatureLayer[]);
    return features;
}

export const queryAttachments = async (props: ArcGisServiceProps, _query: __esri.AttachmentQuery) => {
    const featureSet = await query.executeAttachmentQuery(props.url, _query);
    return featureSet;
}